import React, { useEffect, useState } from 'react';
import Layout from '../layout/Layout';
import { PrivateAxios } from '../../request/axios';
import { toast } from 'react-toastify';
import { FaLock, FaUnlock, FaKey } from 'react-icons/fa';
import Modal from 'react-modal';
import '../../App.css';

// Styles pour le modal
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '400px',
        padding: '20px',
        borderRadius: '10px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)'
    }
};

const ManagerINTUser = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [newPassword, setNewPassword] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const fetchUsers = async () => {
        try {
            const response = await PrivateAxios.get('/manager/int/user');
            setUsers(response.data);
        } catch (err) {
            const errorMsg = err.response ? err.response.data.message : 'Erreur lors du chargement des utilisateurs.';
            setError(errorMsg);
            toast.error(errorMsg, {
                position: "top-right",
                className: "custom-toast"
            });
        } finally {
            setLoading(false);
        }
    };

    const openModal = (user) => {
        setSelectedUser(user);
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setNewPassword("");
        setIsSubmitting(false);
    };

    const toggleUserStatus = async (user) => {
        const newStatus = !user.actif;
        try {
            await PrivateAxios.put(`/manager/int/desactiver/user/${user.id}`, { actif: newStatus });
            toast.success(`Utilisateur ${user.username} ${newStatus ? 'activé' : 'désactivé'} avec succès.`);
            fetchUsers();
        } catch (err) {
            toast.error("Erreur lors de la modification du statut de l'utilisateur.");
        }
    };

    const handlePasswordChange = async () => {
        if (!newPassword || newPassword.trim() === "") {
            toast.error("Le mot de passe ne peut pas être vide.");
            return;
        }

        setIsSubmitting(true);

        try {
            await PrivateAxios.put(`/manager/int/reset/user/${selectedUser.id}`, { password: newPassword });
            toast.success(`Le mot de passe de ${selectedUser.username} a été modifié avec succès.`);
            closeModal();
            fetchUsers();
        } catch (err) {
            toast.error("Erreur lors de la réinitialisation du mot de passe.");
            setIsSubmitting(false);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    const filteredUsers = users.filter(user =>
        user.username.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <Layout>
            <h1 className="mb-6 text-3xl font-bold text-center text-black">Gestion des comptes de mon INT</h1>

            {/* Champ de recherche */}
            <div className="flex justify-center mb-4">
                <input
                    type="text"
                    placeholder="Rechercher par nom d'utilisateur"
                    className="w-1/3 p-2 border border-gray-300 rounded"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>

            {loading ? (
                <p className="text-center">Chargement des utilisateurs...</p>
            ) : error ? (
                <p className="text-center text-red-500">{error}</p>
            ) : (
                <div className="flex justify-center">
                    <div className="w-full mx-auto overflow-x-auto text-center">
                        <table className="w-full bg-white border border-gray-200 rounded-lg shadow-md">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="px-2 py-2 border">ID</th>
                                    <th className="px-2 py-2 border">Nom d'utilisateur</th>
                                    <th className="px-2 py-2 border">Email</th>
                                    <th className="px-2 py-2 border">UG</th>
                                    <th className="px-2 py-2 border">Intermédiaire</th>
                                    <th className="px-2 py-2 border">Statut</th>
                                    <th className="px-2 py-2 border">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredUsers.length > 0 ? (
                                    filteredUsers.map(user => (
                                        <tr key={user.id} className="hover:bg-gray-50">
                                            <td className="px-2 py-2 border">{user.id}</td>
                                            <td className="px-2 py-2 border">{user.username}</td>
                                            <td className="px-2 py-2 border">{user.email}</td>
                                            <td className="px-2 py-2 border">{user.ug_nom}</td>
                                            <td className="px-2 py-2 border">{user.intermediaire_nom}</td>
                                            <td className="px-2 py-2 border">
                                                {user.actif ? (
                                                    <span className="font-semibold text-green-600">Actif</span>
                                                ) : (
                                                    <span className="font-semibold text-red-600">Inactif</span>
                                                )}
                                            </td>
                                            <td className="px-2 py-2 border">
                                                <button
                                                    onClick={() => toggleUserStatus(user)}
                                                    className="mx-2 text-blue-500 hover:text-blue-700"
                                                    title={user.actif ? 'Désactiver' : 'Activer'}
                                                >
                                                    {user.actif ? <FaUnlock /> : <FaLock />}
                                                </button>
                                                <button
                                                    onClick={() => openModal(user)}
                                                    className="mx-2 text-yellow-500 hover:text-yellow-700"
                                                    title="Changer le mot de passe"
                                                >
                                                    <FaKey />
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="py-4 text-center">Aucun utilisateur trouvé.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {/* Modal pour la modification du mot de passe */}
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Modifier le mot de passe"
                ariaHideApp={false}
            >
                <h2 className="mb-4 text-lg font-bold">Modifier le mot de passe de {selectedUser?.username}</h2>
                <input
                    type="password"
                    placeholder="Nouveau mot de passe"
                    className="w-full px-3 py-2 mb-4 border rounded"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                />
                <div className="flex justify-end space-x-4">
                    <button onClick={closeModal} className="px-4 py-2 bg-gray-300 rounded">Annuler</button>
                    <button
                        onClick={handlePasswordChange}
                        className={`px-4 py-2 bg-blue-600 text-white rounded ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}`}
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'En cours...' : 'Valider'}
                    </button>
                </div>
            </Modal>
        </Layout>
    );
};

export default ManagerINTUser;
